/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateResponseBody = {
  /**
   * JWT token for chat session
   */
  clientToken: string;
  /**
   * The origin from which the token will be used
   */
  embedOrigin: string;
  /**
   * Token expiration in seconds
   */
  expiresAfter: number;
  /**
   * Session status
   */
  status: string;
  /**
   * User identifier if provided
   */
  userIdentifier?: string | undefined;
};

/** @internal */
export const CreateResponseBody$inboundSchema: z.ZodMiniType<
  CreateResponseBody,
  unknown
> = z.pipe(
  z.object({
    client_token: z.string(),
    embed_origin: z.string(),
    expires_after: z.int(),
    status: z.string(),
    user_identifier: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_token": "clientToken",
      "embed_origin": "embedOrigin",
      "expires_after": "expiresAfter",
      "user_identifier": "userIdentifier",
    });
  }),
);

export function createResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<CreateResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateResponseBody' from JSON`,
  );
}
